import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
// CSS
import "./menu-page.css";

// Sections
import MenuHero from "../../components/MenuHero/MenuHero";
import MenuCategories from "../../components/MenuCategories/MenuCategories";
import FullMenu from "../../components/FullMenu/FullMenu";

const Menu = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialCategory = queryParams.get("category") || "All";

  const [selectedCategory, setSelectedCategory] = useState(initialCategory);
  const [items, setItems] = useState([]);

  //api call
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(
          "https://ekhoni-khabo-server.vercel.app/api/v1/menu/get-items"
        );
        setItems(response.data.items);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };
    fetchItems();
  }, []);

  useEffect(() => {
    setSelectedCategory(initialCategory);

    if (location.hash === "#full-menu") {
      const fullMenuSection = document.getElementById("full-menu");
      if (fullMenuSection) {
        fullMenuSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [initialCategory, location.hash]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <main className="menu-page">
      <MenuHero />
      <MenuCategories onCategoryClick={handleCategoryClick} />
      <FullMenu selectedCategory={selectedCategory} items={items} />
    </main>
  );
};

export default Menu;
